import React from "react";


import round2 from "../../../../assets/images/round9.webp";
import "./HealthfryRight.css";
import { useNavigate } from "react-router-dom";

const HealthfryRight = () => {
  const navigate = useNavigate();

  return (
    <div className="health-container">
      <div className="container1">
        <div className="content">
          <div className="images">
            <div className="imag1 imag">
              <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/frytabil1.webp" alt="#" />
            </div>
            <div className="imag2 imag">
              <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/frytabil2.webp" alt="#" />
            </div>
          </div>
          <div className="textarea">
            <h1>
              <p>How Fry Right reduces oil consumption </p>{" "}
              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/blackheaderimg.webp" alt="#" />{" "} */}
            </h1>
            <ul>
              <li className="logo">
                <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/shortlogo.webp" alt="#" />
              </li>
              <li>
                <span></span>
                When the quality of your fried food lasts longer, the oil can go
                longer.
              </li>
              <li>
                <span></span>
                When the oil goes longer less oil is used to fill your vats over
                time.
              </li>
              <li>
                <span></span>
                When your crew is taught how to recognize and control Top Off,
                they can significantly reduce oil waste output.{" "}
              </li>
              <li>
                <span></span>
                <p style={{color:"white"}}>
                When oil waste is significantly reduced per month, there is a
                reduction in oil consumption. The Fry Right System’s Quality
                Cycle<sup class="TM">TM &nbsp;</sup> prolongs the quality of the fried food it produces, thus
                reducing the oil consumption of any commercial kitchen that uses
                this system.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <h1 className="foot">
          Be a part of the movement, recycle your oil effectively and
          efficiently, it just makes sense fiscally!
        </h1>
      </div>

      <div className="container2">
        <div className="imag">
          <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/Calculator.webp" alt="#" />
          {/* <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/calckbag.webp" alt="#" /> */}
        </div>
        <div className="textarea">
          <div className="text-con">
           
            <h2>Healthier Food </h2>
           
            <p>
              As the carbon is properly removed from the oil, and the TPMs are
              properly recorded, your customers are consuming safe and thus
              healthier fried food. 24 TPM is no longer fit for human
              consumption. If you cannot see TPMs with the naked eye, how do you
              know you are serving safe fried food? And healthier food also
              tastes better all cycle long! The Fry Right System’s Quality Cycle
              <sup className=" TM">TM &nbsp;</sup>  provides the tools needed to track
              and analyze Cycle TPMs. With this knowledge, Fry Right System
              restaurants are able to safely discard their frying oil before it
              reaches 24 TPMs and becomes unfit for human consumption.
            </p>
          </div>
        </div>
      </div>

      <div className="container3">
        <div className="textarea">
          <h1>Increased Profits</h1>
          <p>
            Using less oil, saving your employees time, and offering better
            tasting food to your customers will increase your profits.&nbsp; 
            <strong>Don't believe it?</strong>
          </p>
        </div>
        {/* <div className="image"> */}
        <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round9.webp" alt="" />
        {/* </div> */}
        <div className="button-grup">
          <button className="but1" onClick={()=>navigate("/testimonials")}>We can prove it</button>
          <button className="but2" onClick={()=>navigate("/contact")} >Schedule a consultation now!</button>
        </div>
      </div>
    </div>
  );
};

export default HealthfryRight;
